import SvgIcon, { SvgIconProps } from "./SvgIcon";

const ConservationIcon: React.FC<SvgIconProps> = ({ ...props }) => {
  return (
    <SvgIcon {...props}>
      <path
        d="M7.54461 19.5256C9.3902 20.3002 10.5399 18.6498 12.2826 18.6149C13.9753 18.6488 15.2343 20.2753 17.0206 19.5256C18.0104 19.1389 18.6873 18.1929 18.6744 17.1263C18.6534 13.9393 15.6941 10.2117 12.2826 10.208C8.85106 10.208 5.44269 14.1946 5.91544 17.5088C6.04836 18.4847 6.70586 19.1979 7.54461 19.5256Z"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M4.38142 11.0335C5.14437 11.0335 5.76285 10.4151 5.76285 9.65218C5.76285 8.88922 5.14437 8.27074 4.38142 8.27074C3.61848 8.27074 3 8.88922 3 9.65218C3 10.4151 3.61848 11.0335 4.38142 11.0335Z"
        // fill="black"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M20.1622 11.0335C20.9253 11.0335 21.5437 10.4151 21.5437 9.65218C21.5437 8.88922 20.9253 8.27074 20.1622 8.27074C19.3994 8.27074 18.7809 8.88922 18.7809 9.65218C18.7809 10.4151 19.3994 11.0335 20.1622 11.0335Z"
        // fill="black"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M9.31123 6.76285C10.0742 6.76285 10.6926 6.14437 10.6926 5.38143C10.6926 4.61848 10.0742 4 9.31123 4C8.54829 4 7.92981 4.61848 7.92981 5.38143C7.92981 6.14437 8.54829 6.76285 9.31123 6.76285Z"
        // fill="black"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
      <path
        d="M15.2339 6.76285C15.9968 6.76285 16.6153 6.14437 16.6153 5.38143C16.6153 4.61848 15.9968 4 15.2339 4C14.4709 4 13.8524 4.61848 13.8524 5.38143C13.8524 6.14437 14.4709 6.76285 15.2339 6.76285Z"
        // fill="black"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
    </SvgIcon>
  );
};

export default ConservationIcon;
